import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-4 col-xl-4 page-title"
}
const _hoisted_2 = { class: "breadcrumb justify-content-sm-start align-items-center mb-0" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  key: 1,
  class: "col-4 col-xl-4 page-title"
}
const _hoisted_5 = { class: "f-w-700" }
const _hoisted_6 = { class: "breadcrumb justify-content-sm-start align-items-center mb-0" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item f-w-400 text-capitalize" }
const _hoisted_9 = {
  key: 0,
  class: "breadcrumb-item f-w-400 text-capitalize"
}
const _hoisted_10 = { class: "breadcrumb-item f-w-400 active" }

import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  setup(__props) {

let route = useRoute()

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(useRoute)().path == '/')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "f-w-700" }, "Default dashboard", -1)),
        _createElementVNode("nav", null, [
          _createElementVNode("ol", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_vue_feather, { type: "home" })
                ]),
                _: 1
              })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("li", { class: "breadcrumb-item f-w-400 text-capitalize" }, "Dashboard", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("li", { class: "breadcrumb-item f-w-400 active text-capitalize" }, "Dashboard Default", -1))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(route).meta.title), 1),
        _createElementVNode("nav", null, [
          _createElementVNode("ol", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_vue_feather, { type: "home" })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, _toDisplayString(_unref(route).path.split('/').slice(1)[0]), 1),
            (_unref(route).path.split('/').slice(1).length > 1 && _unref(route).path.split('/').slice(1).length > 3)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_unref(route).path.split('/').slice(1)[_unref(route).path.split('/').slice(1).length - 2]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_10, _toDisplayString(_unref(route).meta.title), 1)
          ])
        ])
      ]))
}
}

})